import { render, staticRenderFns } from "./orderTrace.vue?vue&type=template&id=253fd8ce&scoped=true&"
import script from "./orderTrace.vue?vue&type=script&lang=js&"
export * from "./orderTrace.vue?vue&type=script&lang=js&"
import style0 from "./orderTrace.vue?vue&type=style&index=0&id=253fd8ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "253fd8ce",
  null
  
)

export default component.exports